






























































import { Vue, Component, Prop, Emit, Model, Ref } from 'vue-property-decorator';
import BaseInput from '../base-input/_base-input.vue';
import BaseIcon from '../base-icon/_base-icon.vue';
import BasePopper from '../base-popper/_base-popper.vue';
import BaseSelectList from './_base-select-list.vue';

@Component({
  name: 'BaseSelect',
  components: {
    BaseInput,
    BaseSelectList,
    BaseIcon,
    BasePopper,
  },
})
export default class BaseSelect extends Vue {
  @Prop() items: any[];
  @Prop() label?: string;
  @Prop({ default: false }) searchable: boolean;
  @Prop({ default: false }) disabled: boolean;
  @Prop() itemLabel?: string;
  @Prop() itemKey?: string;
  @Prop({ default: false }) success: boolean;
  @Prop({ default: '' }) helpMessage: string;
  @Prop({ default: '' }) errorMessage: string;
  @Prop({ default: false }) error: boolean;
  @Prop({ default: '' }) placeholder: string;
  @Prop({ default: '' }) emptyStateText: string;
  @Prop({ default: true }) appendToBody: boolean;

  @Ref('input') input: any;
  @Model('change') value!: any;

  search = '';
  focused = 0;
  open = false;

  get listOffset(): number {
    return this.helpMessage ? -20 : 4;
  }
  get readonly(): boolean {
    return !this.searchable || !this.open;
  }
  get inputValue(): string {
    return this.open && this.searchable ? this.search : this.formattedValue(this.value);
  }
  get inputPlaceholder(): string {
    return this.formattedValue(this.value) || this.placeholder;
  }
  get filteredItems(): any[] {
    if (this.search) {
      const searchRegex = new RegExp(`(\\W|^)${this.search}`, 'i');
      return this.items.filter((item: any) => this.formattedValue(item).search(searchRegex) !== -1);
    }
    return this.items;
  }

  get activeDescendant() {
    return this.open && this.formattedValue(this.filteredItems[this.focused]);
  }

  formattedValue(item: any): string {
    return this.itemLabel ? item?.[this.itemLabel] : item;
  }

  @Emit('change')
  handleChange(item: any) {
    this.reset();
    return item;
  }

  reset() {
    this.search = '';
    this.focused = 0;
    this.open = false;
  }

  handleFocus() {
    if (this.value) {
      this.focused = this.getIndexOfValue();
    }
    this.open = true;
  }

  handleBlur() {
    this.reset();
  }

  getIndexOfValue(): number {
    if (this.itemKey) {
      return this.items.findIndex(item => item[this.itemKey] === this.value[this.itemKey]);
    }
    return this.items.indexOf(this.value);
  }

  handleEnter(event: KeyboardEvent) {
    event.preventDefault();
    if (this.open) {
      if (!this.filteredItems[this.focused]) {
        return;
      }
      this.handleChange(this.filteredItems[this.focused]);
    } else {
      this.handleFocus();
    }
  }

  handleInputUpdate(value: string) {
    this.search = value;
    this.focused = 0;
  }

  handleIconClick() {
    this.input.focus();
  }

  handleNavigate(event: KeyboardEvent) {
    event.preventDefault();

    const firstSelected: boolean = this.focused === 0;
    const lastSelected: boolean = this.focused === this.filteredItems.length - 1;
    let step: number;
    switch (event.key) {
      case 'ArrowUp':
        if (firstSelected) {
          return;
        }
        step = -1;
        break;
      case 'ArrowDown':
        if (lastSelected) {
          return;
        }
        step = 1;
        break;
    }

    this.focused += step;
  }
}
